import { Link } from "@novaescola/eva-react-v2/lib/Link";
import { Typography } from "@novaescola/eva-react-v2/lib/Typography";
import React, { useEffect, useRef } from "react";
import ReactGA from "react-ga";
import { useInView } from "../../hooks/useInView";

const MostRead = ({ allContentMostViewed }) => {
  const mostReadRef = useRef(null);

  const isInView = useInView(mostReadRef);

  useEffect(() => {
    window.dataLayer = window.dataLayer || [];
    const previewEventSent = window.dataLayer.filter(
      (el) =>
        el.label &&
        el.label ===
          "SITE: Click - Nova página de conteúdo - Mais lidas da semana - bloco visualizado"
    );

    if (isInView && previewEventSent.length === 0) {
      window.dataLayer.push({
        event: "block_visualization",
        label:
          "SITE: Click - Nova página de conteúdo - Mais lidas da semana - bloco visualizado",
      });
    }
  }, [isInView]);

  return (
    <div className="most-read">
      <Typography variant="title" size={6} asChild className="eva-color-inst-700 eva-mb-04">
        <p ref={mostReadRef}>Mais lidas da semana</p>
      </Typography>
      <ul className="eva-mb-08">
        {allContentMostViewed.nodes.map((contentNode, index) => (          
          <li className="item" key={index}>                        
            <Link
              href={contentNode.path}
              variant="preto"
              className="item-link eva-font-14"
              data-track={`SITE: Click - Nova página de conteúdo - destaque mais lidas ${contentNode.rankPosition}`}
              onClick={() => {
                ReactGA.event({
                  action: "Click",
                  category: "SITE",
                  label: `Nova página de conteúdo - destaque mais lidas ${contentNode.rankPosition}`,
                });
              }}
            >
              <span className="position">{index + 1}</span>              
              {contentNode.title.replace("| Nova Escola", "")}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default MostRead;
